import { useState } from 'react';
import styles from './EditarPaso.module.css';
import {FaArrowLeft} from 'react-icons/fa';
import Swal from 'sweetalert2';
import { useAuth } from '../../Auth/AuthContext';

const AniadirPaso = ({ onBack, onPasoAdded }) => {
    const [formData, setFormData] = useState({
        pa_titulo: '',
        pa_detalles: '',
        pa_imagen: '',
        pa_descripcion: '',
        pa_nom_subtitulo: ''
    });
    const { getToken } = useAuth();
    const token = getToken();
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [image, setImage] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Validar tipo de archivo
            const allowedTypes = ['image/png'];
            if (!allowedTypes.includes(file.type)) {
                setError('Solo se permiten archivos .png');
                e.target.value = ''; // Limpiar el input
                return;
            }

            // Validar tamaño (5MB)
            if (file.size > 5 * 1024 * 1024) {
                setError('El archivo debe ser menor a 5MB');
                e.target.value = ''; // Limpiar el input
                return;
            }

            setSelectedFile(file);
            setError(''); // Limpiar errores previos

            const reader = new FileReader();
            reader.onload = (e) => {
                setImage(e.target.result);
            };
            reader.readAsDataURL(file);
        };
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar que todos los campos estén llenos
        if (!formData.pa_titulo.trim() || !formData.pa_descripcion.trim() || !formData.pa_detalles.trim() || !formData.pa_nom_subtitulo.trim() || !selectedFile) {
            setError('Todos los campos son obligatorios');
            return;
        }

        setSaving(true);
        setError('');

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('pa_titulo', formData.pa_titulo.trim());
            formDataToSend.append('pa_descripcion', formData.pa_descripcion.trim());
            formDataToSend.append('pa_detalles', formData.pa_detalles.trim());
            formDataToSend.append('pa_nom_subtitulo', formData.pa_nom_subtitulo.trim());
            formDataToSend.append('pa_imagen', selectedFile); // El archivo

            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/crear-paso`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
                body: formDataToSend
            });

            if (!response.ok) {
                const text = await response.text();

                try {
                    const errorData = JSON.parse(text);
                    Swal.fire({
                        title: 'Error al crear paso',
                        text: errorData.message || 'Ocurrió un error en el servidor',
                        icon: 'error',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError(errorData.message || 'Error al crear el paso');
                } catch (parseError) {
                    console.error('No es JSON válido:', text);
                    Swal.fire({
                        title: 'Error de conexión',
                        text: 'No se pudo conectar con el servidor',
                        icon: 'error',
                        timer: 1000,
                        showConfirmButton: false,
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                    setError('Error del servidor');
                }
                return;
            }

            const data = await response.json();
            Swal.fire({
                title: '¡Paso creado!',
                text: `El paso se ha creado correctamente y aparecerá automáticamente en el tablero`,
                icon: 'success',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#242b57',
                timer: 3000,
            }).then(() => {
                // Limpiar formulario
                setFormData({
                    pa_titulo: '',
                    pa_detalles: '',
                    pa_imagen: '',
                    pa_descripcion: '',
                    pa_nom_subtitulo: ''
                });
                setSelectedFile(null);

                // Callbacks si existen
                if (onPasoAdded) onPasoAdded();
                if (onBack) onBack();
            });

        } catch (error) {
            console.error('Error:', error);

            Swal.fire({
                title: 'Error de conexión',
                text: 'No se pudo conectar con el servidor. Verifica tu conexión a internet.',
                icon: 'error',
                showCancelButton: false,
                customClass: {
                    popup: 'popupbonito',
                },
            });

            setError('Error de conexión al crear el paso');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className={styles.formContainerPaso}>
            <div className={styles.headerSection} >
                <button className={styles.btnBack} onClick={onBack}>
                    <FaArrowLeft className={styles.flechaVolver} />
                    Volver a pasos
                </button>
                <h1 className={styles.titulo}>Añadir Paso </h1>
            </div>

            <form className={styles.pasoForm} onSubmit={handleSubmit}>
                <div className={styles.formBody}>
                    <div className={styles.formSection}>
                        <h3>Información de Presentación</h3>

                        <div className={styles.formEdit}>
                            <label htmlFor="pa_titulo">
                                <i className="fi fi-ss-document"></i>
                                Título del Paso
                            </label>
                            <input
                                type="text"
                                id="pa_titulo"
                                name="pa_titulo"
                                value={formData.pa_titulo}
                                onChange={handleInputChange}
                                placeholder="Ej: Mis Desiciones"
                                required
                            />
                        </div>

                        <div className={styles.formEdit}>
                            <label htmlFor="pa_detalles">
                                Detalles del paso
                            </label>
                            <textarea
                                id="pa_detalles"
                                name="pa_detalles"
                                value={formData.pa_detalles}
                                onChange={handleInputChange}
                                placeholder="Escribe un resumen del paso a presentar"
                                rows="4"
                                required
                            />
                        </div>

                        <div className={styles.formEdit}>
                            <label htmlFor="pa_nom_subtitulo">
                                <i />
                                Subtítulo (Título para las secciones)
                            </label>
                            <input
                                type="text"
                                id="pa_nom_subtitulo"
                                name="pa_nom_subtitulo"
                                value={formData.pa_nom_subtitulo}
                                onChange={handleInputChange}
                                placeholder="Ej: Inteligencias"
                                required
                            />
                        </div>

                        <div className={styles.formEdit}>
                            <label htmlFor="pa_descripcion">
                                <i />
                                Descripción (Texto detallado acerca del paso)
                            </label>
                            <textarea
                                id="pa_descripcion"
                                name="pa_descripcion"
                                value={formData.pa_descripcion}
                                onChange={handleInputChange}
                                placeholder="Escribe de forma detallada el contenido del paso"
                                rows="6"
                                required
                            />
                        </div>
                    </div>

                    <div className={styles.formSection}>
                        <h3>Diseño</h3>

                        <div className={styles.formDisenioEdit}>
                            <label htmlFor="pa_imagen">
                                Selecciona una Imagen para el Paso
                                <p><span className={styles.textAyuda}> Elija archivos PNG</span></p>
                                <input
                                    type="file"
                                    id="pa_imagen_file"
                                    name="pa_imagen_file"
                                    accept="image/jpeg,image/png,image/gif"
                                    onChange={handleImageChange}
                                />
                            </label>

                            {formData.pa_imagen && !selectedFile && (
                                <div className={styles.mt2}>
                                    <a>Imagen actual del Paso:</a>
                                    <img
                                        src={
                                            formData.pa_imagen.startsWith('http')
                                                ? formData.pa_imagen
                                                : `${process.env.REACT_APP_API_URL}/pasos/paso-images/${formData.pa_imagen}`
                                        }
                                        alt="Vista previa"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                            )}

                            {selectedFile && (
                                <div className={styles.mt2}>
                                    <span className={styles.textAyuda}>Imagen actual del Paso:</span>
                                    <img src={URL.createObjectURL(selectedFile)} alt="Vista previa nueva" />
                                </div>
                            )}
                        </div>
                        
                        <div className={styles.infoAutomatica}>
                            <p className={styles.textAyuda}>
                                La posición de este paso en el tablero se calculará automáticamente 
                                según el orden de creación.
                            </p>
                        </div>
                    </div>
                </div>

                <div className={styles.formActions}>
                    <button type="submit" className={styles.btnSubmit} disabled={saving}>
                        {saving ? (
                            <>
                                <div className={styles.btnSpinner}></div>
                                Añadiendo...
                            </>
                        ) : (
                            <>
                                Añadir Paso
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AniadirPaso;